import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { GroupTree } from '../entities/schema/grouptree.entity';
import { StatusGroupTree } from '../entities/settings/statusgrouptree.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class StatusGroupTreeService extends ODataEntityService<StatusGroupTree> {
  constructor(protected client: ODataClient) {
    super(client, 'StatusGroupTree', 'entities.settings.StatusGroupTree');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public groupTree(entity: EntityKey<StatusGroupTree>): ODataNavigationPropertyResource<GroupTree> {
    return this.entity(entity).navigationProperty<GroupTree>('groupTree');
  }
  public status(entity: EntityKey<StatusGroupTree>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<StatusGroupTree>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
